module.exports = __webpack_public_path__ + "img/cross-check.e719b900.png";